var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 6.20001C9.62661 6.20001 4.43994 11.3867 4.43994 17.76C4.43994 24.1333 9.62661 29.3333 15.9999 29.3333C22.3733 29.3333 27.5599 24.1467 27.5599 17.7733C27.5599 11.4 22.3733 6.20001 15.9999 6.20001ZM16.9999 17.3333C16.9999 17.88 16.5466 18.3333 15.9999 18.3333C15.4533 18.3333 14.9999 17.88 14.9999 17.3333V10.6667C14.9999 10.12 15.4533 9.66668 15.9999 9.66668C16.5466 9.66668 16.9999 10.12 16.9999 10.6667V17.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8533 4.60002H12.1466C11.6133 4.60002 11.1866 4.17335 11.1866 3.64002C11.1866 3.10669 11.6133 2.66669 12.1466 2.66669H19.8533C20.3866 2.66669 20.8133 3.09335 20.8133 3.62669C20.8133 4.16002 20.3866 4.60002 19.8533 4.60002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTimer);
export default __webpack_public_path__ + "static/media/clock-timer.25993fea393bbe96126718b8159519a2.svg";
export { ForwardRef as ReactComponent };